import './TokenBase-0386597b.css';

var classes = {"TokenBase":"prc-Token-TokenBase-PfQzJ"};

export { classes as default };
